import React from 'react'
import Images from '../../../Assets/images/Images'
import style from './spinner.module.css'

const Spinner = () => {
  return (
    <div className={style.wrapper}>
      <img src={Images.logoblue} alt="Company Logo" className={style.logo} />
      <div className={style.spinner}></div>
    </div>
  )
}

export default Spinner
